var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoading4IconHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 36,
    viewBox: "0 0 39 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0309 3.43297C23.4963 -0.498129 30.3967 -0.367651 34.6986 3.85796C38.9985 8.08543 39.1468 14.8181 35.1472 19.2096L19.0271 35.0383L2.91089 19.2096C-1.08871 14.8181 -0.938535 8.07424 3.35951 3.85796C7.66516 -0.362059 14.5523 -0.503721 19.0309 3.43297V3.43297Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading4IconHeart);
export default __webpack_public_path__ + "static/media/loading4icon_heart.5331ca436f4c2203eadfcec448b05130.svg";
export { ForwardRef as ReactComponent };